import { Capacitor } from "@capacitor/core";

let _platform: string | null = null;
let _isNative: boolean | null = null;

const resolvePlatform = (): string => {
  if (_platform === null) {
    _platform = Capacitor.getPlatform();
  }
  return _platform;
};

const resolveIsNative = (): boolean => {
  if (_isNative === null) {
    _isNative = Capacitor.isNativePlatform();
  }
  return _isNative;
};

export const getPlatform = (): string => resolvePlatform();
export const isNativePlatform = (): boolean => resolveIsNative();

export const isWeb = (): boolean => resolvePlatform() === "web";
export const isAndroid = (): boolean => resolvePlatform() === "android";
export const isIOS = (): boolean => resolvePlatform() === "ios";


export const __resetCapacitorCache = () => {
  _platform = null;
  _isNative = null;
};
